export default __webpack_public_path__ + "static/media/startup.c0c64523.svg";